import Vue from "vue";
import Router from "vue-router";
import store from "./store";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "Home" */ "./views/Home.vue"),
      beforeEnter: (to, from, next) => {
        next();
        if (store.state.home.length === 0) {
          store.dispatch("loadHome");
        }
      },
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "About" */ "./views/About.vue"),
      beforeEnter: (to, from, next) => {
        next();
        if (store.state.about.length === 0) {
          store.dispatch("loadAbout");
        }
      },
    },
    {
      path: "/contact",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "Contact" */ "./views/Contact.vue"),
      beforeEnter: (to, from, next) => {
        next();
        if (store.state.contact.length === 0) {
          store.dispatch("loadContact");
        }
      },
    },
    {
      path: "/projects",
      name: "projects",
      component: () =>
        import(/* webpackChunkName: "Projects" */ "./views/Projects.vue"),
      beforeEnter: (to, from, next) => {
        next();
        if (store.state.projects.length === 0) {
          store.dispatch("loadProjects");
        }
      },
      props: true,
    },
    {
      path: "/imprint",
      name: "imprint",
      component: () =>
        import(/* webpackChunkName: "Imprint" */ "./views/Imprint.vue"),
      beforeEnter: (to, from, next) => {
        next();
        if (store.state.about.length === 0) {
          store.dispatch("loadAbout");
        }
      },
    },
    {
      path: "/policy",
      name: "policy",
      component: () =>
        import(/* webpackChunkName: "Policy" */ "./views/Policy.vue"),
      beforeEnter: (to, from, next) => {
        next();
        if (store.state.policy.length === 0) {
          store.dispatch("loadPolicy");
        }
      },
    },
    {
      path: "/projects/:id",
      name: "project",
      component: () =>
        import(/* webpackChunkName: "Project" */ "./views/Project.vue"),
      beforeEnter: (to, from, next) => {
        store.state.project = [];
        if (store.state.projects.length === 0) {
          store.dispatch("loadProjects");
        }
        // store.dispatch("loadProject", to.params.id);
        next();
      },
      props: true,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
